import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';
export const AllocationUpdated = ({ event }: { event: any }) => {
  const { name } = event?.data?.updateData || {};
  const allocationNameDisplay = name ? (
    <Box as="span" display="inline-block" margin="0 2xs 0 0">
      <strong>{name}</strong> allocation
    </Box>
  ) : (
    'an allocation'
  );

  const updatedFields = event?.data?.updateData ? (
    <Box as="span" display="inline-block" margin="0 2xs 0 0">
      (updated fields:{' '}
      {Object.entries(event.data.updateData)
        .map(([key, value]) => {
          const normalizedKey = key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str) => str.toUpperCase())
            .trim();
          return `${normalizedKey} → ${value}`;
        })
        .join(' | ')}
      )
    </Box>
  ) : null;

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> updated {allocationNameDisplay}
      </Box>
      {updatedFields}
    </Box>
  );
};
